import React from 'react';
import Opportunities from './Opportunities';

const IntegrationOpportunities: React.FC = () => (
  <Opportunities
    title="Integração"
    endpoint="/opportunities/integration"
    emptyStateLabel="Nenhuma vaga de integração encontrada"
    filterPreset="integration"
  />
);

export default IntegrationOpportunities;
